import { FormControl, Input, InputLabel } from "@mui/material";
import { useFormContext } from "react-hook-form";
import daLiJePoljeValidno from "../../../../utils/daLiJePoljeValidno";
import { PorukaGreskePolja } from "../../../index";

const Index = ({ field, index, update, nazivPolja }: any) => {
  const { register } = useFormContext();
  return (
    <FormControl fullWidth error={!daLiJePoljeValidno(nazivPolja)}>
      <InputLabel htmlFor={nazivPolja}>Identifikacijski broj (Identification number)</InputLabel>
      <Input
        id={`${nazivPolja}`}
        value={field.identifikacijskiBroj}
        {...register(nazivPolja)}
        onChange={(e: React.ChangeEvent<any>) =>
          update(index, {
            ...field,
            identifikacijskiBroj: e.target.value,
          })
        }
      />
      <PorukaGreskePolja nazivPolja={nazivPolja} />
    </FormControl>
  );
};

export default Index;
